// @core/api/endpoints/notifications/update_tenant_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTenantSettingsRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update tenant notification settings
 * Updates the notification settings for a tenant. Changes affect all users in the tenant unless overridden by individual preferences.
 */
export async function UpdateTenantSettings(
  tenant_id: string,
  data: UpdateTenantSettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/settings`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
